export const getCourseExtents = (siteSettingsData, mapsData, setCourseExtents) => {
  let courseExtent = [];

  if (siteSettingsData && mapsData != null) {
    var upperLeft = new mapsData.LatLng(siteSettingsData.UpperLeftLatitude, siteSettingsData.UpperLeftLongitude);

    var lowerRightLatitude = siteSettingsData.UpperLeftLatitude - 2 * (siteSettingsData.UpperLeftLatitude - siteSettingsData.CenterPointLatitude);

    var lowerRightLongitude = siteSettingsData.UpperLeftLongitude + 2 * (siteSettingsData.CenterPointLongitude - siteSettingsData.UpperLeftLongitude);

    var lowerRight = new mapsData.LatLng(lowerRightLatitude, lowerRightLongitude);

    courseExtent.push(upperLeft);
    courseExtent.push(lowerRight);
    setCourseExtents.set(courseExtent);
  }
};
